



























































































































































































































































import Agent from '@/components/Agent.vue';
import Button from '@/atomics/Button.vue';
import Icon from '@/components/Icon.vue';
import Notification from '@/atomics/notifications/Notification.vue';
import QueueChunk from '@/components/QueueChunk.vue';
import Queue from '@/components/Queue.vue';
import SelectMultipleQueue from '@/components/select/multiple/queue/SelectMultipleQueue.vue';
import Select, { SelectOption } from '@/components/form/Select.vue';
import Toogle from '@/components/form/Toogle.vue';
import Tabs, { TabOption } from '@/components/Tabs.vue';
import Vision, { VisionMode } from '@/utils/vision';
import WebSocket from '@/socket';
import Veil from '@/atomics/Veil.vue';
import { Channel } from 'phoenix';
import {
    Component,
    Vue as VueBase,
    Inject,
    Prop,
    Provide,
} from 'vue-property-decorator';
import {
    Status,
    State,
    CustomStatus,
    AgentCustomStatus,
} from '@/utils/agent';
import createAgentChannel from '@/utils/agent/channel';
import createQueueChannel from '@/utils/queue/channel';
import idealName from '@/utils/ideal-name';
import createMaintenanceChannel from '@/utils/maintenance/channel';
import {
    AgentChannel, OfferAgent, Registration, Agent as AgentStore,
} from '@/store/modules/agent';
import { QueueMemberCall, QueueChannel, Queue as QueueStore } from '@/store/modules/queue';
import Logger from '@/utils/logger/logger';
import Spinner from '@/atomics/loaders/Spinner.vue';
import { UpdateLoadingAgent } from '@/store/modules/agent/events';
import { UpdateLoadingQueue } from '@/store/modules/queue/events';
import PanelCore from '@/core/Panel';
import PanelFilter from '@/components/PanelFilter.vue';
import ModalSettings from '@/components/panel/ModalSettings.vue';
import Tooltip from '@/components/Tooltip.vue';
import Filter from '@/core/panel/Filter';
import Setting from '@/core/panel/Setting';
import HttpClient from '@/api/http-client';
import UserInfo, { PermissionIssue } from '@/core/userinfo';
import StorageQueueVisibility from '@/core/queues/StorageVisibility';
import StorageQueueOrder from '@/core/queues/StorageOrder';
import InfoBox from '@/components/InfoBox.vue';
import PermissionAlert from '@/components/PermissionAlert.vue';
import { maxQueuesVisibleAllowed } from '@/store/modules/queue/getters';
import { toCamelCase } from '@/utils/text';
import PanelConfig from '@/components/panel/PanelConfig.vue';

enum TabFooterOption {
    Agents = 'agents',
    Queues = 'queues'
}

const VOICEBOT_PRIORITY_CUSTOMER_IDS = new Set<number>([214, 2, 1387]);
const VOICEBOT_PRIORITY_DOMAINS = new Set<string>([
    'sharewoods.myflexpbx.com',
    'vip2pbx.myflexpbx.com',
    'donottouchonlydev.myflexpbx.com',
]);
const VOICEBOT_PREFIX = 'voicebot@';

function matchesAgentFilter(agent: AgentStore, text: string): boolean {
    const metadataName = agent.metadata?.name;
    const normalizedMetadataName = typeof metadataName === 'string' ? metadataName.toLowerCase() : '';
    const agentName = typeof agent.name === 'string' ? agent.name : '';

    return normalizedMetadataName.startsWith(text) || agentName.startsWith(text);
}

@Component({
    components: {
        Agent,
        Button,
        Icon,
        Notification,
        Queue,
        Select,
        Tabs,
        Toogle,
        QueueChunk,
        Spinner,
        PanelFilter,
        ModalSettings,
        Tooltip,
        Veil,
        SelectMultipleQueue,
        InfoBox,
        PermissionAlert,
        PanelConfig,
    },
})
export default class Panel extends VueBase {
    tabFooterOptions: Array<TabOption> = [];

    tabFooterActived = TabFooterOption.Agents;

    agents: Array<AgentStore> = [];

    selectedAgents: Array<AgentStore> = [];

    isFooterExpanded = false;

    isFooterMinimized = true;

    isEquiposSidebarVisible = true;

    queues: Array<QueueStore> = [];

    queuesLoaded = false;

    agentsLoaded = false;

    registrations = new Map<string, Registration>();

    vision: Vision = Vision.new();

    visionMode: VisionMode = VisionMode.Maximized;

    wantedExtension = '';

    statusOptions: Array<SelectOption>= [];

    loadedTime = Date.now();

    maxQueuesVisibleAllowed = maxQueuesVisibleAllowed;

    storageQueueOrder !: StorageQueueOrder;

    protected showWaitingCallsWarning = false;

    protected queuesWithWaitingCalls = '';

    @Inject('logger') logger!: Logger;

    @Inject('httpClient') http!: HttpClient;

    panel: PanelCore = PanelCore.fromView(Filter.fromPanel(), Setting.fromPanel());

    @Prop(UserInfo) readonly userInfo!: UserInfo;

    @Prop(Object) readonly socket!: WebSocket;

    @Provide('storagePrefix') storagePrefix: string = toCamelCase(
        `${this.userInfo.username}-${this.userInfo.currentDomain}`,
    );

    private hasTriedAutoDomainChange = false;

    private wasDisconnected = false;

    created() {
        this.$store.commit('setStorageVisibility', StorageQueueVisibility.create(this.storagePrefix));

        this.storageQueueOrder = StorageQueueOrder.create(this.storagePrefix);

        this.reportPermissionIssues();

        this.statusOptions = [
            {
                name: this.$t(`agent.custom_status.${CustomStatus.Available}`).toString(),
                value: CustomStatus.Available,
            },
            {
                name: this.$t(`agent.custom_status.${CustomStatus.Unavailable}`).toString(),
                value: CustomStatus.Unavailable,
            },
            {
                name: this.$t(`agent.custom_status.${CustomStatus.Busy}`).toString(),
                value: CustomStatus.Busy,
            },
            {
                name: this.$t('agent.custom_status.offline').toString(),
                value: CustomStatus.Offline,
            },
            { name: this.$t(`agent.status.${Status.NotAssign}`).toString(), value: '' },
        ];

        this.tabFooterOptions = [
            { name: this.$tc('agent.agent', 2), value: TabFooterOption.Agents, selected: true },
            { name: this.$tc('queue.queue', 2), value: TabFooterOption.Queues, selected: false },
        ];

        const maintenanceChannel = createMaintenanceChannel(this.socket);
        maintenanceChannel.join().receive('error', (response) => {
            this.logger.captureError(response);
            console.error('Unable to join on maintenance', response);
        });

        const agentsChannel: Channel = this.socket.channel('agents:all');
        const queuesChannel: Channel = this.socket.channel('queues:all');

        const joinTimeout = 240000;

        this.socket.onClose(() => {
            this.wasDisconnected = true;
        });

        this.socket.onOpen(() => {
            if (this.wasDisconnected) {
                const currentIndex = this.userInfo.customers.findIndex((c) => c.domain === this.userInfo.currentDomain);
                const indexToUse = currentIndex !== -1 ? currentIndex : 0;
                this.onChangeDomain(indexToUse);
            }
        });

        queuesChannel.on('all_queues', (data) => {
            this.queuesLoaded = true;
            this.initQueues(data.queues);

            data.queues.forEach((queue: QueueChannel) => {
                const updateLoadingQueue: UpdateLoadingQueue = { isLoading: false, name: queue.name };

                const channel = createQueueChannel(queue.name, this.socket, this.$store, () => {
                    this.$store.dispatch('isLoadingQueue', updateLoadingQueue);
                });

                this.$store.dispatch(
                    'addQueueToContainer',
                    {
                        name: queue.name,
                        tiers: [],
                        visible: this.$store.getters.storageVisibility.getQueueVisibility(queue.name),
                        membersCount: 0,
                        callsAnswered: 0,
                        agentOffers: new Map<string, OfferAgent>([]),
                        memberCalls: new Map<string, QueueMemberCall>([]),
                        metadata: { name: queue.metadata?.name },
                        isLoading: true,
                        channel,
                    },
                );
                channel.join(joinTimeout).receive('error', (err) => {
                    this.logger.captureError(err);
                    this.$store.dispatch('isLoadingQueue', updateLoadingQueue);
                }).receive('timeout', () => {
                    this.$store.dispatch('isLoadingQueue', updateLoadingQueue);
                });
            });
        });

        agentsChannel.on('all_agents', (data) => {
            this.agentsLoaded = true;
            this.agents = data.agents;
            this.registrations = new Map(Object.entries(data.registrations));
            this.selectedAgents = data.agents;

            data.agents.forEach((agent: AgentChannel) => {
                const updateLoadingAgent: UpdateLoadingAgent = { name: agent.name, isLoading: false };

                const channel = createAgentChannel(agent.name, this.socket, this.$store, () => {
                    this.$store.dispatch('isLoadingAgent', updateLoadingAgent);
                });

                this.$store.dispatch(
                    'addAgentToContainer',
                    {
                        name: agent.name,
                        tiers: [],
                        status: Status.None,
                        state: State.None,
                        callStates: new Map(),
                        queueCalls: new Map(),
                        isLoading: true,
                        metadata: { name: agent.metadata.name },
                        connected: this.registrations.has(agent.name),
                        lastActivityAtSecs: 0,
                        channel,
                        previousState: State.None,
                        doNotDisturb: false,
                    },
                );
                channel.join(joinTimeout).receive('error', (err) => {
                    this.$store.dispatch('isLoadingAgent', updateLoadingAgent);
                    this.logger.captureError(err);
                }).receive('timeout', () => {
                    this.$store.dispatch('isLoadingAgent', updateLoadingAgent);
                });
            });
        });

        queuesChannel.on('queues_stats', (data) => {
            const updatedQueueStats = { queueStats: data.queue_stats };
            this.$store.dispatch('updateQueueStats', updatedQueueStats);
            this.$root.$emit('queue_stats', data.queue_stats);
        });

        agentsChannel.on('update_registrations', (data) => {
            this.registrations = new Map<string, Registration>(Object.entries(data.registrations));
        });

        agentsChannel.join(joinTimeout).receive('error', (response) => {
            this.logger.captureError(response);
            console.error('Unable to join on agents:all', response);
            this.tryAutoChangeDomain();
        });

        queuesChannel.join(joinTimeout).receive('error', (response) => {
            this.logger.captureError(response);
            console.error('Unable to join on queues:all', response);
            this.tryAutoChangeDomain();
        });

        this.$root.$on('changeDomain', (index: number) => {
            this.onChangeDomain(index);
        });
    }

    minimizeFooter() {
        this.isFooterMinimized = !this.isFooterMinimized;
        this.isFooterExpanded = !this.isFooterExpanded;
    }

    toggleEquiposSidebar() {
        this.isEquiposSidebarVisible = !this.isEquiposSidebarVisible;
    }

    onChangeOptions(selected: Array<string>) {
        if (selected.length === 0) {
            this.selectedAgents = this.agents;
        } else {
            this.selectedAgents = this.agents.filter((agent) => {
                const agentStore = this.$store.getters.getAgentByName(agent.name);
                const customStatus = AgentCustomStatus.fromAgent(
                    agentStore.status,
                    agentStore.state,
                    agentStore.previousState,
                );
                return (selected.includes(customStatus.status()) && agentStore.connected)
                        || (selected.includes(CustomStatus.Offline) && !agentStore.connected)
                        || (selected.includes('') && agentStore.status === '');
            });
        }
    }

    onChangeFooterOption(option: TabFooterOption) {
        this.tabFooterActived = option;
    }

    isTabFooterAgents() {
        return this.tabFooterActived === TabFooterOption.Agents;
    }

    isTabFooterQueues() {
        return this.tabFooterActived === TabFooterOption.Queues;
    }

    onToogleIdleTime(): void {
        if (this.panel.setting.idleTimeHidden) {
            this.$store.dispatch('refreshConnectedAgentsLastActivity');
        }
        this.panel.setting.toogleIdleTime();
    }

    onToogleAdvancedStats(): void {
        this.panel.setting.toogleAdvancedStats();
        this.panel = PanelCore.fromView(
            this.panel.filter,
            new Setting({
                idleTimeHidden: this.panel.setting.idleTimeHidden,
                advancedStats: this.panel.setting.advancedStats,
            }),
        );
    }

    onChangeDomain(index: number): void {
        const { domain } = this.userInfo.customers[index];

        this.http
            .patch('/user_domain', { user: { domain } })
            .then(() => window.location.reload())
            .catch((err) => console.error('Cambio de dominio falló:', err));
    }

    changeQueuesOrder(queuesOrder: QueueStore[]) {
        this.queues = [...queuesOrder];

        this.storageQueueOrder.saveCustomOrder(this.queues);
    }

    changeVision(visionToChange: string): void {
        const vision = this.vision as any;

        this.visionMode = vision[visionToChange]();
    }

    toggleSettingsModal(): void {
        const modal = this.$refs.modalSettings as any;

        modal.toogle();
    }

    get footerMinimizedIcon() {
        return this.isFooterMinimized ? 'arrows-expand' : 'minus';
    }

    get permissionIssues(): PermissionIssue[] {
        return this.userInfo.getPermissionIssues();
    }

    get currentCustomerId(): number {
        const customer = this.userInfo.customers.find(
            (c) => c.domain === this.userInfo.currentDomain,
        );
        return customer?.id || 0;
    }

    get filteredAgents() {
        const text = this.wantedExtension.toLowerCase();

        try {
            return this.selectedAgents
                .filter((agent): boolean => matchesAgentFilter(agent, text))
                .sort(this.sortAgent);
        } catch (error) {
            this.capturePanelError(error);
            return this.selectedAgents;
        }
    }

    protected shouldDisableAgentActions(agentName: string): boolean {
        try {
            return this.isTargetVoicebotAgent(agentName);
        } catch (error) {
            this.capturePanelError(error);
            return false;
        }
    }

    protected get userHasWaitingCallsFunctionality() {
        return this.userInfo.username === 'PWRJORGE'
        || this.userInfo.username === 'ABALUARTE3'
        || this.userInfo.username === 'VQUIJANO1'
        || this.userInfo.username === 'JUANGONZALEZ'
        || this.userInfo.username === 'JOVATESTPCX';
    }

    private sortAgent(a: AgentStore, b: AgentStore) {
        try {
            const prioritizedVoicebot = this.sortVoicebotFirst(a, b);
            if (prioritizedVoicebot !== 0) {
                return prioritizedVoicebot;
            }

            if (this.$store.getters.agentExtensionName(a.name) < this.$store.getters.agentExtensionName(b.name)) {
                return -1;
            }
            return 1;
        } catch (error) {
            this.capturePanelError(error);
            return 0;
        }
    }

    private sortVoicebotFirst(a: AgentStore, b: AgentStore): number {
        const isVoicebotA = this.isTargetVoicebotAgent(a.name);
        const isVoicebotB = this.isTargetVoicebotAgent(b.name);

        if (isVoicebotA && !isVoicebotB) {
            return -1;
        }

        if (!isVoicebotA && isVoicebotB) {
            return 1;
        }

        return 0;
    }

    private isTargetVoicebotAgent(agentName: string): boolean {
        if (!this.isVoicebotPriorityEnabled()) {
            return false;
        }

        const currentDomain = this.userInfo?.currentDomain;
        if (!currentDomain) {
            return false;
        }

        const expectedVoicebotName = `${VOICEBOT_PREFIX}${currentDomain}`.toLowerCase();
        return agentName.toLowerCase() === expectedVoicebotName;
    }

    private isVoicebotPriorityEnabled(): boolean {
        const currentDomain = this.userInfo?.currentDomain;
        if (!currentDomain) {
            return false;
        }

        const currentCustomer = this.userInfo.customers.find((customer) => customer.domain === currentDomain);

        return VOICEBOT_PRIORITY_CUSTOMER_IDS.has(currentCustomer?.id ?? -1)
            || VOICEBOT_PRIORITY_DOMAINS.has(currentDomain);
    }

    private capturePanelError(error: unknown): void {
        if (this.logger && this.logger.captureError) {
            const normalizedError = error instanceof Error ? error : new Error(String(error));
            this.logger.captureError(normalizedError);
        }
    }

    private initQueues(queues: QueueStore[]) {
        const queuesWithCustomOrder = this.storageQueueOrder.getCustomOrder();

        this.queues = [...queuesWithCustomOrder];

        const queuesNotInStorage = queues.filter((queue) => queuesWithCustomOrder.find(
            (queueWithCustomOrder) => queueWithCustomOrder.name === queue.name,
        ) === undefined);

        queuesNotInStorage.forEach((queue) => {
            this.queues.push(queue);
        });
    }

    protected checkIfShowWaitingCallsWarning(): void {
        const showNotifications = window.localStorage.getItem('showNotifications');

        if (showNotifications === 'false') {
            return;
        }

        let showNotification = false;

        this.showWaitingCallsWarning = false;

        this.queuesWithWaitingCalls = '';

        const minNumberOfWaitingCallsToShowWarning = 1;
        const queuesNames: string[] = [];

        this.queues.forEach((element) => {
            const membersCount = this.$store.getters.queueMembersCount(element.name);

            if (membersCount >= minNumberOfWaitingCallsToShowWarning) {
                queuesNames.push(idealName(element.name));

                showNotification = true;
            }
        });

        if (showNotification) {
            this.showNotification();
        }

        this.queuesWithWaitingCalls = queuesNames.join(', ');
    }

    protected async showNotification() {
        this.showWaitingCallsWarning = true;

        await new Promise((resolve) => setTimeout(resolve, 6000));

        this.showWaitingCallsWarning = false;
    }

    protected hideNotification(): void {
        this.showWaitingCallsWarning = false;
    }

    /**
     * Intenta cambiar el dominio automáticamente al primero disponible si ocurre un error en el join de canales.
     * Solo lo intenta una vez para evitar loops infinitos.
     */
    // una vez por sesion y dominio: cada recarga del panel no es un caso nuevo para soporte
    private reportPermissionIssues(): void {
        const { username, currentDomain } = this.userInfo;
        const reportedKey = `permissionMisconfigReported:${currentDomain}`;

        if (this.permissionIssues.length === 0 || sessionStorage.getItem(reportedKey) === '1') {
            return;
        }

        sessionStorage.setItem(reportedKey, '1');
        this.logger.captureWarning('permission_misconfig', {
            username,
            domain: currentDomain,
            issues: this.permissionIssues.join(','),
        });
    }

    private tryAutoChangeDomain() {
        if (this.hasTriedAutoDomainChange) return;
        this.hasTriedAutoDomainChange = true;
        if (this.userInfo && Array.isArray(this.userInfo.customers) && this.userInfo.customers.length > 0) {
            const { currentDomain, customers } = this.userInfo;
            const firstAvailableIndex = customers.findIndex((c) => c.domain !== currentDomain);
            const indexToUse = firstAvailableIndex !== -1 ? firstAvailableIndex : 0;
            this.onChangeDomain(indexToUse);
        }
    }
}
